export const engineeringClassificationConstants = {
  // 取得列表資料
  GET_LIST_REQUEST: "ENGINEERING_CLASSIFICATION_GET_LIST_REQUEST",
  GET_LIST_SUCCESS: "ENGINEERING_CLASSIFICATION_GET_LIST_SUCCESS",
  GET_LIST_FAILURE: "ENGINEERING_CLASSIFICATION_GET_LIST_FAILURE",
  RESET_LIST_SUCCESS: "ENGINEERING_CLASSIFICATION_RESET_LIST_SUCCESS"
};
